import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './Navbar.css';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const closeMenu = () => {
    setIsOpen(false);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <Link to="/" className="navbar-logo" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
          JF
        </Link>

        <div className={`hamburger ${isOpen ? 'active' : ''}`} onClick={toggleMenu}>
          <span className="bar"></span>
          <span className="bar"></span>
          <span className="bar"></span>
        </div>

        <ul className={`nav-menu ${isOpen ? 'active' : ''}`}>
          <li className="nav-item">
            <Link to="/projects" className="nav-link" onClick={closeMenu}>work</Link>
          </li>
          <li className="nav-item nav-dot">·</li>
          <li className="nav-item">
            <Link to="/about" className="nav-link" onClick={closeMenu}>about</Link>
          </li>
          <li className="nav-item nav-dot">·</li>
          <li className="nav-item">
            <Link to="/contact" className="nav-link" onClick={closeMenu}>contact</Link>
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default Navbar;
